export const pageWhoNoAccessConstant = [
  '/main',
  '/procurement',
  '/procurement/planning/container-plan',
  '/procurement/planning/container-calendar',
  '/procurement/pr/requests-without-tender',
  '/procurement/supplier-management/journal-supplier-audit',
  '/commercial-documents/agreements/from-template',
  '/commercial-documents/agreements/treaties-journal',
  '/commercial-documents'
];
